<template>
  <v-app id="inspire">
    <div v-if="pageType === 'intro'">
      <ServiceInit></ServiceInit>
    </div>
    <div v-else>
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        ref="appNavigation"
      >
        <v-list dense>
          <template v-for="item in items">
            <v-list-item :key="item.text" link>
              <router-link class="navigation-router-link" :to="item.toPath">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <p class="subtitle-2 mb-0">{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="blue darken-3"
        dark
        ref="appBar"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 500px" class="ml-0 pl-4">
          <span class="hidden-sm-and-down hover" @click="moveHome()">{{
            appTitle
          }}</span>
        </v-toolbar-title>
        <v-spacer />
        <AppVersion></AppVersion>
      </v-app-bar>
      <v-content>
        <v-container class="height" fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<style scoped>
.navigation-router-link {
  color: unset;
  text-decoration: none;
  width: 100%;
  display: flex;
}
.v-list-item--disabled {
  pointer-events: auto;
}

.hover {
  cursor: pointer;
  text-decoration: none;
}
.hidden-sm-and-down.hover:hover {
  text-decoration: aliceblue;
  text-decoration-skip-ink: none;
  text-decoration: underline;
}
</style>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import { MEMBERSHIP_SERVICE } from "@/datas/membership";
import { CONFIG } from "@/datas/configs.js";
import "@/assets/style/common.css";

//import ServiceInit from "@/views/membership/ServiceInit.vue";
const ServiceInit = () =>
  import(
    /* webpackChunkName: "MemebershipAppServiceInit" */ "@/views/membership/ServiceInit.vue"
  );

//import AppVersion from "@/components/membership/version/AppVersion.vue";
const AppVersion = () =>
  import(
    /* webpackChunkName: "MemebershipAppAppVersion" */ "@/components/membership/version/AppVersion.vue"
  );

export default {
  components: {
    ServiceInit,
    AppVersion,
  },
  props: {
    source: String,
  },
  data() {
    return {
      MEMBERSHIP_SERVICE,
      CONFIG,
      pageType: "intro",
      appTitle: "[쇼핑몰명] 유료 멤버십 서비스",
      drawer: null,
      unPlus: {
        color: "#8C8C8C",
      },
      items: [
        {
          icon: "mdi-home",
          text: "홈",
          toPath: `/membership/${this.$store.state.mallId}/home`,
        },
        {
          icon: "mdi-account-cog",
          text: "멤버십 설정/관리",
          toPath: `/membership/${this.$store.state.mallId}/membershipManage`,
        },
        {
          icon: "mdi-clipboard-plus-outline",
          text: "부가서비스",
          toPath: `/membership/${this.$store.state.mallId}/additionalService`,
        },
      ],
    };
  },
  mixins: [CommonMixin],
  methods: {
    moveHome: function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/home`,
      });
    },
  },
  created: function() {
    document.title = "평생 멤버십 서비스";
    //this.appTitle = `[ ${this.$store.state.mallName} ] 유료 멤버십 서비스`;
    this.appTitle = `[medicube] 평생 멤버십 서비스`;
    const url_path = window.location.pathname;
    this.pageType = url_path === "/membership/init" ? "intro" : "page";

    let acess_token = sessionStorage.getItem(
      `${this.$store.state.mallId}_accessToken`
    );
    if (!acess_token) {
      alert("비정상적인 접근입니다.");
      location.replace("https://eclogin.cafe24.com/Shop/");
    }
  },
};
</script>
